$(document).ready(function(){

  if($('.cart-collection-main-cls ul').length > 0){
    if($('.cart-collection-main-cls ul .owl-stage-outer').length == 0){
      $('.cart-collection-main-cls ul').owlCarousel({
        loop: true,
        autoplay: false,
        dots: true,
        nav: false,
        dotsEach: true,
        margin: 10,
        autoHeight:true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1.02
            }
        }
      })     
    }
  }
})